// The layout editor's save, out of LayoutEditScreen (chain 9 of the backfill, Oct 2026): the
// gates the save runs in order before its request, and the body PUT /api/layouts/:id gets.

export const DUPLICATE_LAYOUT_CONFIRM =
  'Dieses Layout scheint ein Duplikat zu sein. Möchtest du es trotzdem speichern?'; // the question the save asks before saving a layout that duplicates a saved one

export const layoutSaveStop = (
  {
    layoutJsonError,
    layoutValidationProblems,
    duplicateLayoutMatches,
    overlappingKeycapProblems,
    packagingError,
  },
  { confirmDuplicate, packagingConsistencyError }
) => {
  if (layoutJsonError) {
    // if the editor contains invalid JSON:
    return {
      message:
        'Das Layout-JSON ist ungültig und kann nicht gespeichert werden.',
    };
  }

  if (layoutValidationProblems.length > 0) {
    // if the parsed layout contains invalid structure or values:
    return {
      message:
        'Dieses Layout enthält ungültige Werte oder Strukturen und kann nicht gespeichert werden.',
    };
  }

  if (overlappingKeycapProblems.length > 0) {
    // if keycaps overlap in the edited layout:
    return {
      message:
        'Dieses Layout enthält überlappende Keycaps und kann nicht gespeichert werden.',
    };
  }

  if (packagingError) {
    return {
      message:
        'Es konnte kein passender Foam für dieses Layout gefunden werden.',
    }; // blocks saving while the automatic packaging selection has an error
  }

  const consistencyError = packagingConsistencyError(); // checks whether all selected packaging components exist and use the same size

  if (consistencyError) {
    return { message: consistencyError }; // blocks saving when the selected packaging documents are incomplete or inconsistent
  }

  if (duplicateLayoutMatches.length > 0 && !confirmDuplicate()) {
    return { declined: true }; // the admin does not want to save the duplicate layout
  }

  return null;
}; // why the save stops, in the order the gates run: the message the screen toasts, or the declined duplicate question, which toasts nothing; null when the request may go out. The question comes last, once no gate refuses the save (it came before the overlap and packaging stops until chain 9, so an admin confirmed a duplicate the next gate then refused; user decision, Oct 2026)

export const layoutUpdateBody = ({
  layoutName,
  tags,
  isFinished,
  isActualLayout,
  matchesRealKeyArrangement,
  layout,
  size,
  numOfKeycaps,
  alternativeNames,
  keyboardModels,
  cardboardBox,
  foamLid,
  foamBase,
  transferFilmId,
  transferFilmQuantitiesByProfile,
  allowFilmPooling,
}) => ({
  layoutName: layoutName,
  tags: tags,
  isFinished: isFinished,
  isActualLayout: isActualLayout,
  matchesRealKeyArrangement,
  layout: layout,
  size: size,
  numOfKeycaps: numOfKeycaps,
  alternativeNames: alternativeNames,
  keyboardModels: keyboardModels,
  cardboardBox: cardboardBox,
  foamLid: foamLid,
  foamBase: foamBase,
  transferFilm: {
    id: transferFilmId,
    quantitiesByProfile: transferFilmQuantitiesByProfile,
    allowFilmPooling: allowFilmPooling,
  },
}); // the body the save sends: the editor's fields under the names the route writes (layoutRoutes.js reads each from the body and takes the layout's id from the address; the body carried the id unread until chain 9, a review), the transfer film as the model's sub-document: its id, the films each profile needs and the pooling switch
